import { NgModule, ModuleWithProviders } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// import { PuiAppbar, PuiDesktop, PuiStatusBar } from './index';
import { PuiLayoutService, PuiLayoutPlacement } from '../../core/index';
import { PuiElementsModule } from '../elements/elements.module';

import { PuiDesktopComponent } from './structure/desktop.component';
import { PuiBasicComponent } from './structure/basic.component';
import { PuiAppbarComponent } from './appbar/appbar.component';
import { PuiStatusBarComponent } from './status-bar/status-bar.component';
import { PuiSidebarComponent } from './sidebar/sidebar.component';
import { PuiDefaultFooterComponent } from './default-footer.component';

const LAYOUT_COMPONENTS = [
  PuiDefaultFooterComponent,
  PuiAppbarComponent,
  PuiDesktopComponent,
  PuiBasicComponent,
  PuiSidebarComponent,
  PuiStatusBarComponent
];

@NgModule({
  declarations: LAYOUT_COMPONENTS,
  entryComponents: [
    PuiDefaultFooterComponent
  ],
  imports: [
    PuiElementsModule,
    BrowserModule,
    CommonModule,
    FormsModule,
    RouterModule
  ],
  exports: LAYOUT_COMPONENTS,
})
export class PuiLayoutModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: PuiLayoutModule, providers: [] };
  }
  constructor(layoutService: PuiLayoutService) {
    layoutService.register(PuiDefaultFooterComponent, PuiLayoutPlacement.Footer);
  }
}
